export enum windowComparisonType {
  Starting = 1,
  On = 2,
  Until = 3,
}

export const windowComparisonTypeName = {
  [windowComparisonType.Starting]: "Starting",
  [windowComparisonType.On]: "On",
  [windowComparisonType.Until]: "Until"

}